import React, { Component } from "react";
// import {Form, Breadcrumb, Button} from 'react-bootstrap';
import "moment/locale/id.js";
import { DatePickerInput } from "rc-datepicker";
import "rc-datepicker/lib/style.css";
import CurrencyFormat from "react-currency-format";
import { usePromiseTracker } from "react-promise-tracker";
import { isEmpty, map } from "lodash";
import { trackPromise } from "react-promise-tracker";
import Loader from "react-loader-spinner";

import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBContainer,
  MDBNavbar,
  MDBNavbarNav,
  MDBNavItem,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBSwitch,
  MDBFileInput,
  MDBRangeInput,
  MDBSelect,
  MDBSelectInput,
  MDBSelectOptions,
  MDBSelectOption,
  MDBLink,
  MDBBtn,
  MDBTable,
} from "mdbreact";
// import remSep from "string-remove-thousand-separators";

const LoadingIndicator = (props) => {
  const { promiseInProgress } = usePromiseTracker();

  return (
    promiseInProgress && (
      <div
        style={{
          width: "100%",
          height: "100",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
        }}
      >
        <Loader type="ThreeDots" color="#3c8dbc" height={100} width={100} />
      </div>
    )
  );
};

class Tambah_ms_student extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      field: "",
      // type: "",
      type_text: "",
      pdf_table: "",
      // pdf_field: "",
      list: [],
    };
  }

  componentDidMount() {
    this._onSearchContent();
  }

  async _onSearchContent(params = {}) {
    this.setState({
      isEdit: false,
      name: "",
      field: "",
      type: "",
      type_text: "",
      pdf_table: "",
      listorganisasi: [],
    });
    await trackPromise(
      fetch(global.variable.LINK_API + "settings/master/listMsStudent", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + global.cookies.get("access_token"),
        },
        //body: JSON.stringify(data)
      })
        .then((response) => response.json())
        .then((resData) => {
          if (!isEmpty(resData)) {
            this.setState({ list: resData, is_show: true });
            // this._onChecked(resData[0]);
          }
        })
    );
  }

  onChange = (e) => {
    var a = e.target.value;
    a = a.replace("/", "");
    a = a.replace('"', "");
    this.setState({ [e.target.name]: a });
  };

  onDropdownSelected(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onChangeDate = (jsDate, dateString) => {
    this.setState({ dob: dateString });
  };

  validateForm() {
    return this.state.name.length > 0;
    //&& this.state.birth_certificate.length > 0;
  }

  handleSubmit = (event) => {
    event.preventDefault();
    console.log("state 1 " + JSON.stringify(this.state));
    this.state.redirect_to = "/" + this.state.redirect_to;

    fetch(global.variable.LINK_API + "settings/master/createMsStudent", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + global.cookies.get("access_token"),
      },
      body: JSON.stringify(this.state),
    })
      .then((response) => response.json())
      .then((resData) => {
        console.log(resData);
        if (resData.message === "Success") {
          global.swal("Success", resData.message, "success").then((value) => {
            this._onSearchContent();
          });
        } else {
          global.swal("Error", resData.error, "info");
        }
      })
      .catch((err) => {
        if (err) {
          if (err.code !== 403) {
            global.swal("Error", "Koneksi ke server gagal.", "info");
          }
        } else {
          global.swal.stopLoading();
          global.swal.close();
        }
      });
  };

  handleUpdate = (event) => {
    event.preventDefault();

    this.state.redirect_to = "/" + this.state.redirect_to;

    fetch(global.variable.LINK_API + "settings/master/editMsStudent", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + global.cookies.get("access_token"),
      },
      body: JSON.stringify(this.state),
    })
      .then((response) => response.json())
      .then((resData) => {
        console.log(resData);
        if (resData.message === "Success") {
          global.swal("Success", resData.message, "success").then((value) => {
            this._onSearchContent();
          });
        } else {
          global.swal("Error", resData.error, "info");
        }
      })
      .catch((err) => {
        if (err) {
          if (err.code !== 403) {
            global.swal("Error", "Koneksi ke server gagal.", "info");
          }
        } else {
          global.swal.stopLoading();
          global.swal.close();
        }
      });
  };

  handleBack = () => {
    window.location.href = "/pendaftaran";
  };

  createSelectItems() {
    let items = [];
    items.push(
      <option value="1" key={1}>Textbox</option>,
      <option value="2" key={2}>Combobox</option>
    );
    return items;
  }

  createSelectTypeText() {
    let items = [];
    items.push(
      <option value="text" key={1}>Text</option>,
      <option value="nominal" key={2}>Nominal</option>,
      <option value="number" key={3}>Number</option>,
      <option value="date" key={4}>Date</option>
    );
    return items;
  }

  onClickEdit(val) {
    const { history } = this.props;
    window.scrollTo(0, 0);
    this.setState({
      isEdit: true,
      id: val.id,
      name: val.name,
      field: val.field,
      type: val.type,
      type_text: val.type_text,
      pdf_table: val.pdf_table,
    });
  }

  render() {
    const { location } = this.props;
    const { state = {} } = location;
    const { data } = state;
    const { list, form, isEdit } = this.state;
    return (
      <div className="content-wrapper">
        <section className="content-header">
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                <div className="divContainter">
                  <MDBCard className="mb-5">
                    <MDBCardBody>
                      <MDBBreadcrumb color="cyan lighten-4">
                        <MDBBreadcrumbItem active>
                          <a href="/home">Home</a>
                        </MDBBreadcrumbItem>
                        {/* <MDBBreadcrumbItem active>
                          <a href="/pengaturanumum">Pengaturan Umum</a>
                        </MDBBreadcrumbItem> */}
                        <MDBBreadcrumbItem active>
                          Tambah Ms Student
                        </MDBBreadcrumbItem>
                      </MDBBreadcrumb>

                      <form
                        onSubmit={
                          isEdit ? this.handleUpdate : this.handleSubmit
                        }
                      >
                        <div className="form-row">
                          <div className="form-group col-md-6">
                            <label>Field <span className="text-danger">*</span></label>
                            <input
                              className="form-control"
                              type="Text"
                              name="field"
                              maxLength="100"
                              value={this.state.field}
                              onChange={this.onChange}
                              required
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Nama Field <span className="text-danger">*</span></label>
                            <input
                              className="form-control"
                              type="Text"
                              name="name"
                              maxLength="100"
                              value={this.state.name}
                              onChange={this.onChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-group col-md-6">
                            <label>Tipe Inputan <span className="text-danger">*</span></label>
                            <select
                              id="exampleForm2"
                              type="text"
                              className="form-control"
                              name="type"
                              value={this.state.type}
                              onChange={this.onDropdownSelected.bind(this)}
                              required
                            >
                              <option value="">- Pilih Tipe Input-</option>
                              {this.createSelectItems()}
                            </select>
                          </div>
                        {this.state.type == 1 ? (
                          <div className="form-group col-md-6">
                            <label>Tipe Text <span className="text-danger">*</span></label>
                            <select
                              id="exampleForm2"
                              className="form-control"
                              name="type_text"
                              value={this.state.type_text}
                              onChange={this.onDropdownSelected.bind(this)}
                              required
                            >
                              <option value="">- Pilih Tipe Input-</option>
                              {this.createSelectTypeText()}
                            </select>
                          </div>
                        )
                        : (
                            <div className="form-group col-md-6">
                              <label>Pdf Table <span className="text-danger">*</span></label>
                              <input
                                className="form-control"
                                type="Text"
                                name="pdf_table"
                                maxLength="100"
                                value={this.state.pdf_table}
                                onChange={this.onChange}
                                required = {this.state.type == 2? true:false}
                              />
                            </div>
                        )}
                        </div>


                        <MDBBtn color="primary" block type="submit">
                          {isEdit ? "Update" : "Submit"}
                        </MDBBtn>
                      </form>
                      <br></br>
                      <div className="form-group">
                        <MDBTable bordered>
                          <thead className="blue-grey lighten-4">
                            <tr>
                              <th style={{ textAlign: "center" }}>No</th>
                              <th style={{ textAlign: "center" }}>field</th>
                              <th style={{ textAlign: "center" }}> Nama Field</th>
                              <th style={{ textAlign: "center" }}>Tipe</th>
                              <th style={{ textAlign: "center" }}>Tipe Text</th>
                              <th style={{ textAlign: "center" }}>pdf_table</th>
                              <th style={{ textAlign: "center" }}> Opsi </th>
                            </tr>
                          </thead>
                          <tbody>
                            {list.map((data, idx) => {
                              return (
                                <tr key={idx}>
                                  <td style={{ textAlign: "center" }}>
                                    {idx + 1}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {data.field}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {data.name}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {data.type == 1? "Textbox" : "Combobox"}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    
                                    {data.type_text}
                                    {/* {data.type_text == 2 && ("Nominal")}
                                    {data.type_text == 3 && ("Number")}
                                    {data.type_text == 4 && ("Date")} */}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {data.pdf_table}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <MDBBtn
                                      color="primary"
                                      block
                                      onClick={() => this.onClickEdit(data)}
                                    >
                                      Edit
                                    </MDBBtn>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </MDBTable>
                        <LoadingIndicator />
                      </div>
                    </MDBCardBody>
                  </MDBCard>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Tambah_ms_student;
